export const PASSWORD_SYMBOLS = '()[]{}|\\`~!@#$%^&*_-+=;:\'",<>./?'

export const PASSWORD_RULES = [
  { id: 'length', label: 'At least 18 characters', test: (value) => value.length >= 18 },
  { id: 'uppercase', label: 'At least one uppercase letter', test: (value) => /[A-Z]/.test(value) },
  { id: 'lowercase', label: 'At least one lowercase letter', test: (value) => /[a-z]/.test(value) },
  {
    id: 'symbol',
    label: `At least one symbol: ${PASSWORD_SYMBOLS}`,
    test: (value) => value.split('').some((character) => PASSWORD_SYMBOLS.includes(character)),
  },
  { id: 'notNumeric', label: 'Not entirely numeric', test: (value) => !/^\d+$/.test(value) },
]

export const isPasswordValid = (value) => PASSWORD_RULES.every((rule) => rule.test(value))
